import {ActionTypes} from '../actions';
import {ActionTypes as InternalOrdersTypes} from '../../binning/actions';
import createReducer from '../../common/util/createReducer';

const FORM_INITIAL_STATE = {
  'loading': false,
  'saving': false,
  'values': {
    'code': '',
    'warehouse': '',
    'reason': '',
    'adjustmentType': '',
    'jdeType': '',
    'description': '',
    'detail': [],
  },
};

const updateItemInfo = (currentValues, action) => {
  if (!currentValues) {
    return currentValues;
  }

  const {detail} = currentValues;

  if (detail) {
    return {
      ...currentValues,
      'detail': [
        ...detail.slice(0, action.payload),
        {...detail[action.payload], ...action.response.data},
        ...detail.slice(action.payload + 1),
      ],
    };
  }

  return {...currentValues};
};

export const stockAdjustmentForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.CLEAR_ADJUSTMENT_INFO]: (state, action) => ({
      ...state,
      ...FORM_INITIAL_STATE,
      'values': {
        ...state.values,
        ...FORM_INITIAL_STATE.values,
      },
    }),
    [ActionTypes.FETCHING_STOCK_ADJUSTMENT_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_STOCK_ADJUSTMENT_INFO]: (state, action) => ({
      ...state,
      'loading': false,
      'values': action.response.data,
    }),
    [ActionTypes.FETCHED_STOCK_ADJUSTMENT_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATING_NEW_ADJUSTMENT]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.CREATED_NEW_ADJUSTMENT]: (state, action) => ({
      ...state,
      'saving': false,
      'values': action.response.data,
    }),
    [ActionTypes.CREATED_NEW_ADJUSTMENT_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.PROCESSING_STOCK_ADJUSTMENT]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.PROCESSED_STOCK_ADJUSTMENT]: (state, action) => ({
      ...state,
      'saving': false,
      'values': action.response.data,
    }),
    [ActionTypes.PROCESSED_STOCK_ADJUSTMENT_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [InternalOrdersTypes.VERIFYING_STOCK_IN_WAREHOUSE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [InternalOrdersTypes.VERIFIED_STOCK_IN_WAREHOUSE]: (state, action) => ({
      ...state,
      'loading': false,
      'currentIndex': action.payload,
      'values': updateItemInfo(state.values, action),
    }),
    [InternalOrdersTypes.VERIFIED_STOCK_IN_WAREHOUSE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'currentIndex': null,
    }),
    [ActionTypes.ADDING_ADJUSTMENT_ITEM]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.ADDED_ADJUSTMENT_ITEM]: (state, action) => ({
      ...state,
      'saving': false,
      'currentIndex': null,
      'values': {
        ...state.values,
        'detail': [
          ...state.values.detail.slice(0, action.payload),
          {...state.values.detail[action.payload], ...action.response.data},
          ...state.values.detail.slice(action.payload + 1),
          {},
        ],
      },
    }),
    [ActionTypes.ADDED_ADJUSTMENT_ITEM_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),

    [ActionTypes.REMOVING_ADJUSTMENT_ITEM]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.REMOVED_ADJUSTMENT_ITEM]: (state, action) => ({
      ...state,
      'saving': false,
      'currentIndex': null,
      'values': {
        ...state.values,
        'detail': [
          ...state.values.detail.slice(0, action.payload),
          ...state.values.detail.slice(action.payload + 1),
        ],
      },
    }),
    [ActionTypes.REMOVED_ADJUSTMENT_ITEM_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.UPDATING_STOCK_ADJUSTMENT_STATE]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.UPDATED_STOCK_ADJUSTMENT_STATE]: (state, action) => ({
      ...state,
      'saving': false,
      'values': action.response.data,
    }),
    [ActionTypes.UPDATED_STOCK_ADJUSTMENT_STATE_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
  })(state, action);
};
